import React, {useState, useEffect} from 'react'
import {Row, Col, ConfigProvider, Button, Form, Input, Select, Table, message} from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'
import {SFuncModal} from "shj-components";
import {lostBatchDispatch} from "@/services/saleOpServices.ts";
import {getEmployee} from "@/services/customerServices.ts";

const {Option} = Select

const AssignDesign: React.FC<any> = ({onClose, listRef, ...rest}) => {
  const {ids} = rest
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState<any[]>([])
  const [filterList, setFilterList] = useState<any[]>([])
  const [select, setSelect] = useState<Record<string, any>>()
  const [searchData, setSearchData] = useState({name: 'userName', input: ''})
  const onFinish = () => {
    if (!select) {
      message.error(`请选择一个设计师`)
      return
    }
    setLoading(true)
    lostBatchDispatch({
      trackPlanIds: ids,
      relatives: {
        ucenterUserId: (select as any).ucenterUserId,
        name: (select as any).userName,
        deptId: (select as any)?.orgId,
        companyId: (select as any)?.companyId,
        roleCode: (select as any)?.roleCode,
      }
    }).then(() => {
          message.success('操作成功')
          onClose()
          listRef.current.reload()
        })
        .finally(() => {
          setLoading(false)
        })
  }
  const change = (v: any, name: string) => {
    const _data = {...searchData}
    if (name == 'input') {
      _data[name] = v.target.value
    } else {
      _data[name] = v
    }
    setSearchData(_data)
  }
  const search = () => {
    const _list = list
        .filter((item: any) => {
          if (item[searchData.name] && item[searchData.name]?.indexOf(searchData.input) != -1 || !searchData.input) return item
        })
        .map((item, i) => {
          return {...item, uuid: item.uuid || `item_${i}`}
        })
    setFilterList(_list)
  }
  const reset = () => {
    setSearchData({...searchData, input: ''})
    setFilterList([...list])
  }
  useEffect(() => {
    getEmployee({ queryEmployee: true, queryOrg: true, pageSize: 99999 }).then(resp => {
      setList(resp.list)
      setFilterList(
      [...resp.list].map((item, i) => {
        return { ...item, uuid: item.uuid || `item_${i}` }
      })
    )
    })
  }, [])

  return (
      <SFuncModal.Content
          confirmLoading={loading}
          onCancel={onClose}
          onOk={onFinish}
      >
        <Form form={form}>
          <Row style={{marginBottom: 10}}>
            <Col span={12}>
              {'设计师: ' +
                  (select ? select.orgNamePath + '-' + select.userName : '')}
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={4}>
              <Form.Item>
                <Select
                    onChange={v => {
                      change(v, 'name')
                    }}
                    value={searchData.name}
                >
                  <Option value="userName">姓名</Option>
                  <Option value="userPhone">电话</Option>
                  <Option value="orgNamePath">部门</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item>
                <Input
                    placeholder={'请输入'}
                    onChange={v => {
                      change(v, 'input')
                    }}
                    value={searchData.input}
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Button
                  type="primary"
                  style={{marginRight: 10}}
                  onClick={() => {
                    search()
                  }}
              >
                查询
              </Button>
              <Button onClick={reset}>重置</Button>
            </Col>
          </Row>
          <Table
              rowSelection={{
                type: 'radio',
                onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
                  // const _list = [...tableSelect];
                  // _list[index] = selectedRows[0];
                  // setTableSelect(_list);
                  setSelect(selectedRows[0])
                },
              }}
              scroll={{y: 350}}
              dataSource={filterList}
              rowKey="uuid"
              columns={[
                {title: '姓名', dataIndex: 'userName'},
                {title: '电话', dataIndex: 'userPhone'},
                // {title: '工号', dataIndex: 'workNumber'},
                // {title: '公司', dataIndex: 'companyName'},
                {title: '部门', dataIndex: 'orgNamePath'},
                {title: '职位', dataIndex: 'roleName'},
              ]}
          />
        </Form>
      </SFuncModal.Content>
  )
}

export function assignDesign({listRef, ...rest}) {
  const onClose = () => {
    dialog.destroy()
  }

  const dialog = SFuncModal({
    title: `指定分配`,
    width: 1000,
    vanish: true,
    content: (
        <ConfigProvider locale={zhCN}>
          <AssignDesign onClose={onClose} listRef={listRef} {...rest} />
        </ConfigProvider>
    ),
  })

  return dialog
}
